module.exports = __webpack_public_path__ + "img/healthy-population.68d061fc.svg";